﻿export class Document {
    private readonly _id: string;

    public get id(): string {
        return this._id;
    }

    private readonly _fileName: string;

    public get fileName(): string {
        return this._fileName;
    }

    private readonly _folders: string[];

    public get folders(): string[] {
        return this._folders;
    }

    constructor(fullName: string, id: string) {
        if (fullName === ``) {
            throw new Error(`A filename cannot be empty.`);
        }

        this._id = id;

        const nameParts: string[] = fullName.split(`/`),
            partsLength = nameParts.length;

        this._fileName = nameParts[partsLength - 1];
        this._folders = [];

        for (let i = 0; i < partsLength - 1; i++) {
            this._folders.push(nameParts[i]);
        }
    }
}
